<template>
  <div>
  <nav class="bg-white border-b border-gray-200" v-if="user.email">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center cursor-pointer" @click="goto('/')">
            <img class="block lg:hidden h-8 w-auto" src="@/assets/logo.svg" alt="Workflow">
            <img class="hidden lg:block h-8 w-auto" src="@/assets/logo.svg" alt="Workflow">
          </div>
          <div class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
            <!-- Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
            <a @click="goto('/')" :class='currentSelection == "jobs" ? "border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer":"border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer"' aria-current="page">
              Jobs
            </a>
            <a v-if="user.type=='admin'" @click="goto('/users')" :class='currentSelection == "users" ? "border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer":"border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer"' aria-current="page">
              Users
            </a>

            <a @click="goto('/studios')" :class='currentSelection == "studios" ? "border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer":"border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer"' aria-current="page">
              Studios
            </a>

            <a @click="goto('/monthly')" :class='currentSelection == "monthly" ? "border-indigo-500 text-gray-900 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer":"border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium cursor-pointer"' aria-current="page">
              Monthly
            </a>
          </div>
        </div>
        <div class="hidden sm:ml-6 sm:flex sm:items-center">

          <!-- Profile dropdown -->
          <div class="ml-3 relative">
            <div>
              <button type="button" class="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" aria-expanded="false" aria-haspopup="true" @click="profileMenu = !profileMenu" >
                <span class="sr-only">Open user menu</span>
                <span class="inline-flex items-center justify-center h-8 w-8 rounded-full" v-bind:style="{backgroundColor:getRGB(user.email)}">
                  <span class="text-sm font-medium leading-none text-white">{{user.email[0]}}</span>
                </span>
              </button>
            </div>

            <!--
              Dropdown menu, show/hide based on menu state.

              Entering: "transition ease-out duration-200"
                From: "transform opacity-0 scale-95"
                To: "transform opacity-100 scale-100"
              Leaving: "transition ease-in duration-75"
                From: "transform opacity-100 scale-100"
                To: "transform opacity-0 scale-95"
            -->
            <div class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1" v-if="profileMenu">
              <!-- Active: "bg-gray-100", Not Active: "" -->
              <a @click="goto('/settings')" class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:text-gray-900" role="menuitem" tabindex="-1" id="user-menu-item-0">
                Settings
              </a>

              <a @click="logout()" class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:text-gray-900" role="menuitem" tabindex="-1" id="user-menu-item-2">
                Sign out
              </a>
            </div>
          </div>
        </div>
        <div class="-mr-2 flex items-center sm:hidden">
          <!-- Mobile menu button -->
          <button type="button" class="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click='toggleMenu()'>
            <span class="sr-only">Open main menu</span>
            <!--
              Heroicon name: outline/menu

              Menu open: "hidden", Menu closed: "block"
            -->
            <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" v-if="!mobileMenu">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <!--
              Heroicon name: outline/x

              Menu open: "block", Menu closed: "hidden"
            -->
            <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" v-if="mobileMenu">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile menu, show/hide based on menu state. -->
    <div class="sm:hidden" id="mobile-menu"  v-if="mobileMenu">
      <div class="pt-2 pb-3 space-y-1">
        <!-- Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800" -->
        <a @click="goto('/')" class="bg-indigo-050 border-indigo-500 text-indigo-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">
          Jobs
        </a>

        <a v-if="user.type=='admin'" @click="goto('/users')" class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">
          Users
        </a>

        <a @click="goto('/studios')" class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">
          Studios
        </a>

        <a @click="goto('/monthly')" class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">
          Monthly
        </a>
      </div>
      <div class="pt-4 pb-3 border-t border-gray-200">
        <div class="flex items-center px-4">
          <div class="flex-shrink-0" @click="goto('/settings')">
                <span class="inline-flex items-center justify-center h-10 w-10 rounded-full" v-bind:style="{backgroundColor:getRGB(user.email)}">
                  <span class="font-medium leading-none text-white">{{user.email[0]}}</span>
                </span>
          </div>
          <div class="ml-3" @click="goto('/settings')">
            <div class="text-base font-medium text-gray-800">{{user.firstname}}</div>
            <div class="text-sm font-medium text-gray-500">{{user.email}}</div>
          </div>
          <button class="ml-auto bg-white flex-shrink-0 p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="logout()">
            <span class="sr-only">View notifications</span>
            <!-- Heroicon name: outline/bell -->
                        
                <svg xmlns="http://www.w3.org/2000/svg" class="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
</svg>
          </button>
        </div>
      </div>
    </div>
  </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import  avatarGenerator from "./../../services/avatarGenerator";

export default {
  name: "Navbar",
  data() {
    return {
        mobileMenu: false,
        profileMenu: false,
        currentSelection: 'jobs'
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "currentUser",
    }),
  },
  methods: {
        logout() {
      this.$store.dispatch("user/logoutUser");
    },
      toggleMenu() {
          this.mobileMenu = !this.mobileMenu;
      },
      goto(path){
        this.mobileMenu = false;
        this.$router.push({ path })
        this.updateSelection(path)
      },
      getRGB(name){
        return avatarGenerator.getRGB(name)
      },
      updateSelection(path){
        if(path == '/') this.currentSelection = 'jobs'
        if(path == '/users') this.currentSelection = 'users'
        if(path == '/studios') this.currentSelection = 'studios'
        if(path == '/monthly') this.currentSelection = 'monthly'
      }
  },
  beforeCreate() {
    this.$store.dispatch("user/getUser");
  },
  created(){
    this.updateSelection(window.location.pathname)
  }
};
</script>